import styled from '@emotion/styled';
import mediaQuery from '@/lib/styling/mediaQuery';
import addBorderInHighContrastMode from '@/lib/styling/addBorderInHighContrastMode';

const getWidthStylesForColumnCount = (columnCount: number) => {
  const widthString = `calc(${100 / columnCount}% - 24px)`;

  return {
    minWidth: widthString,
    maxWidth: widthString,
  };
};

const StyledInfoField = styled('div')(
  ({ theme }) => ({
    marginLeft: 12,
    marginRight: 12,
    padding: 16,
    ...getWidthStylesForColumnCount(5),
    background: theme.palette.action.hover,
    borderRadius: 4,
    boxSizing: 'border-box',
    [mediaQuery(1024)]: {
      marginBottom: 24,
      ...getWidthStylesForColumnCount(3),
      ':nth-of-type(4), :nth-of-type(5)': {
        marginBottom: 0,
      },
    },
    [mediaQuery(768)]: {
      ...getWidthStylesForColumnCount(2),
      ':nth-of-type(4)': {
        marginBottom: 24,
      },
    },
    [mediaQuery(560)]: getWidthStylesForColumnCount(1),
  }),
  addBorderInHighContrastMode,
);

export default StyledInfoField;
